module.exports = __webpack_public_path__ + "img/TJ.bc17f365.svg";